/*! dependencies: cash */

instant.youtube = {
  status: {
    apiLoading: false,
    apiLoaded: false
  },
  init: function () {
    instant.youtube.addCookieInformationEvents();

    cash('body').on('click', '.js-media--youtube', function () {
      if (!CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
        alert(instant.settings.youMustGiveCookieConsent);
      }
    });
  },
  bindEvents: function () {
    cash('body').on('mouseenter', '.js-media--youtube', instant.youtube.loadApi);
    cash('body').on('click', '.js-media--youtube', function () {
      var video = cash(this),
        showInModal = video.hasClass('js-show-in-modal');
      if (showInModal) {
        var modal = video.find('.js-video-modal',);
        var modalClone = instant.modal.show.element(modal, {
          //obscure: { opacity: 0.5 }
        });
        modalClone.find('iframe').attr('id', 'modalVideo');
        instant.youtube.startVideo(modalClone);
        //console.log('modal now', modalClone);
      } else {
        instant.youtube.startVideo(video);
      }
    });
  },
  startVideo: function (mediaEle, autoplay) {
    if (instant.youtube.status.apiLoaded) {
      new YT.Player(mediaEle.find('iframe').attr('id'), {
        events: {
          'onReady': function onPlayerReady (event) {
            //console.log('onReady');
            if (autoplay) {
              event.target.mute();
            }
            event.target.playVideo();

            if (mediaEle.is('.js-enable-controls')) {
              mediaEle.find('.js-video-overlay').remove();
            } else {
              mediaEle.find('.js-video-overlay').addClass('opacity-0').removeClass('cursor-pointer');
            }
            // Used to remove custom overlays, set by RibbonMedia
            mediaEle.parents('.ribbonMedia').find('.js-media-overlay').remove();
          }
        }
      });

      mediaEle.find('.js-video-overlay').remove();
    } else {
      mediaEle.addClass('js-media--youtube--queued');
      instant.youtube.loadApi();
    }
  },
  loadApi: function () {
    if (!instant.youtube.status.apiLoaded && !instant.youtube.status.apiLoading) {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';

      document.head.appendChild(tag);

      instant.youtube.status.apiLoading = true;
    }
  },
  apiLoaded: function () {
    _paq.push(['MediaAnalytics::scanForMedia']);
    instant.youtube.status.apiLoaded = true;
    instant.youtube.status.apiLoading = false;

    cash('.js-media--youtube--queued').each(function () {
      var video = cash(this);

      instant.youtube.startVideo(video, true);
      video.removeClass('js-media--youtube--queued');
    });
  },

  addCookieInformationEvents: function () {
    window.addEventListener('CookieInformationConsentGiven', function (event) {
      if (CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
        instant.youtube.bindEvents();
        //console.log('CONSENT Youtube');
        var iframes = cash('.js-media--youtube iframe');
        for (i = 0; i < iframes.length; i++) {
          var iframe = cash(iframes[i]);
          iframe.attr('src', iframe.data('src'));
        }
      }
    }, false);
  }
};

window.onYouTubeIframeAPIReady = instant.youtube.apiLoaded;